import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ImagemSetor from 'assets/img/setores.svg';
import InputText from 'components/InputText';
import InputSelect from 'components/InputSelect';
import InputTextArea from 'components/InputTextArea';
import Button from 'components/Button';
import { openModalConfirmacao } from 'components/Modal/ModalConfirmacao';
import CardAtendentes from './cardAtendentes';
import { clearErroChange } from 'utils/formUtils';
import { ALERTA, MSG_SETOR_DELETADO_SUCESSO } from 'utils/consts';
import { ENUM_PERMISSAO } from 'utils/permissao';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { fetchDeletarSetor } from 'store/fetchActions/fetchSetores';
import { setorSistemaEditar, setorSistemaListar } from 'routes/paths';
import * as S from '../styles';
import { altImageSetor } from 'utils/acessibilidade';

export default function ContainerSetor({
  errors,
  control,
  setValue,
  setError,
  optionsSituacoes,
  handleSubmit,
  onSubmit,
  disabled = false,
  listaAtendentes,
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [exibirEditar, setExibirEditar] = useState(false);
  const [exibirApagar, setExibirApagar] = useState(false);

  const user = useSelector(state => state.sefaz.userProfile);
  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const setorDetalhar = useSelector(state => state.setor?.setorDetalhar);

  React.useEffect(() => {
    if (unitaryTests) return;
    if (user?.permission.includes(ENUM_PERMISSAO.SUP0901.codigo)) setExibirEditar(true);
    if (user?.permission.includes(ENUM_PERMISSAO.SUP0902.codigo)) setExibirApagar(true);
  }, [user, unitaryTests]);

  const handleChange = e => {
    const { name, value } = e.target;
    setValue(name, value);
    clearErroChange(name, value, errors, setError);
  };

  const deletarSetor = () => {
    dispatch(fetchDeletarSetor(setorDetalhar?.id)).then(() => {
      history.push(setorSistemaListar);
      fetchNotificationApp(MSG_SETOR_DELETADO_SUCESSO, '', ALERTA.SUCESSO);
    });
  };

  return (
    <form>
      <Row>
        <Col xs={24} sm={6} md={6} lg={6} xl={6}>
          <S.Descricao>
            Para cadastrar um Setor preencha todas as informações solicitadas, o setor ficará disponível para todos os
            atendentes imediatamente após salvar.
          </S.Descricao>
          <S.ContainButton>
            {disabled && exibirEditar && (
              <Button text={'Editar'} clickAction={() => history.push(setorSistemaEditar)} />
            )}
            {disabled && exibirApagar && (
              <Button
                text={'Deletar'}
                clickAction={() => openModalConfirmacao({ funcSuccess: deletarSetor })}
                css={{ corSecundaria: '#ffffff', cor: '#C62828' }}
              />
            )}
          </S.ContainButton>

          <InputText
            label="* Nome do Setor"
            name="nomeSetor"
            errors={errors}
            placeholder={'Nome do Setor'}
            control={control}
            onChange={handleChange}
            maxLength={100}
            disabled={disabled}
          />
          <InputTextArea
            label="* Descrição do Setor"
            name="descricaoSetor"
            errors={errors}
            placeholder={'Descrição do Setor'}
            control={control}
            onChange={handleChange}
            maxLength={300}
            rows={5}
            disabled={disabled}
          />
          <InputText
            label="E-mail do Setor"
            name="email"
            errors={errors}
            placeholder={'E-mail do Setor'}
            control={control}
            onChange={handleChange}
            maxLength={100}
            disabled={disabled}
          />
          <InputSelect
            label="* Status"
            name="situacaoId"
            errors={errors}
            placeholder={'Status'}
            control={control}
            options={optionsSituacoes}
            disabled={disabled}
          />
          {disabled && listaAtendentes && <CardAtendentes atendentes={listaAtendentes} />}
        </Col>
        <Col xs={24} sm={16} md={16} lg={16} xl={16} style={{ margin: 'auto' }}>
          <S.ImagemSetorSistema data-testid="Imagem Page Setor" src={ImagemSetor} alt={altImageSetor} />
        </Col>
      </Row>
      {!disabled && <Button text={'Salvar'} clickAction={handleSubmit(onSubmit)} css={{ margin: '7px 0px 7px 7px' }} />}
    </form>
  );
}
